import { useCallback } from 'react';
import * as dashboardService from '../services/dashboardService';

// Hook específico para dashboard
export function useDashboard() {
  const getDashboardStats = useCallback(
    async (userId: string, userRole: string) => {
      return await dashboardService.getDashboardStats(userId, userRole);
    },
    []
  );

  const getDashboardActivity = useCallback(
    async (userId: string, userRole: string, specialty?: string) => {
      return await dashboardService.getDashboardActivity(
        userId,
        userRole,
        specialty
      );
    },
    []
  );

  return {
    getDashboardStats,
    getDashboardActivity,
  };
}
